import axios, {AxiosError} from "axios";
import * as React from "react";

import Icon from "./FontAwesomeIcon";

import * as Style from "./DataLoader.scss";

const Loading = () => (
    <div className={Style.info}>
        <Icon icon="spinner" spin size="lg" />
    </div>
);

const Failure = () => (
    <div className={Style.info}>
        <span className="text-danger">Error loading Data</span>
    </div>
);

const NotFound = () => (
    <div className={Style.info}>
        <span className="text-danger">404 Not Found</span>
    </div>
);

interface Props<T> {
    url: string;
    success(data: T): React.ReactNode;
    loading?(): React.ReactNode;
    notFound?(): React.ReactNode;
    failure?(): React.ReactNode;
}

interface State<T> {
    data: T | undefined;
    error: AxiosError | undefined;
}

class DataLoader<T = any> extends React.Component<Props<T>, State<T>> {
    static defaultProps = {
        loading: () => <Loading />,
        notFound: () => <NotFound />,
        failure: () => <Failure />,
    };

    constructor(props: Props<T>) {
        super(props);

        this.state = {
            data: undefined,
            error: undefined,
        };
    }

    private fetchData(url: string) {
        axios
            .get<T>(url)
            .then((response) => {
                const data = response.data;
                this.setState({data});
            })
            .catch((error) => {
                this.setState({error});
            });
    }

    componentDidMount() {
        const {url} = this.props;

        this.fetchData(url);
    }

    componentDidUpdate(prevProps: Props<T>) {
        const {url} = this.props;

        if (url !== prevProps.url) {
            this.fetchData(url);
        }
    }

    render() {
        const {failure, notFound, loading, success} = this.props;
        const {data, error} = this.state;

        if (data) {
            return success(data);
        } else if (error) {
            if (error.response?.status === 404) {
                return notFound ? notFound() : null;
            } else {
                return failure ? failure() : null;
            }
        } else {
            return loading ? loading() : null;
        }
    }
}

export default DataLoader;
